import { render, staticRenderFns } from "./AgregarButton.vue?vue&type=template&id=b0d027e6&scoped=true&"
import script from "./AgregarButton.vue?vue&type=script&lang=ts&"
export * from "./AgregarButton.vue?vue&type=script&lang=ts&"
import style0 from "./AgregarButton.vue?vue&type=style&index=0&id=b0d027e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d027e6",
  null
  
)

export default component.exports